<aside @showDivFaq *ngIf="sessionData.strongAuthSms" class="related-content right">   
   <div *ngIf="sessionData.agreementType === 'A' || sessionData.agreementType === 'P'" class="title">
       <span class="faq-title">{{'FAQ.TITULO_PERGUNTAS_FREQUENTES' | translate}}</span>
   </div>

   <div *ngIf="sessionData.agreementType === 'A' || sessionData.agreementType === 'P'" class="question-div first">
        <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q1">{{'FAQ.O_QUE_E_OPEN_BANKING' | translate}}</div>
        <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q1"></button>
        <div id="q1" class="collapse">
            <span class="faq-answer">{{'FAQ.DESCRICAO_O_QUE_E_OPEN_BANKING' | translate}}</span> 
        </div>
   </div>

   <div *ngIf="sessionData.agreementType === 'A'">
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q2">{{'FAQ.QUE_INFORMACAO_PODE_SER_CONSULTADA' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q2"></button>
            <div id="q2" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_QUE_INFORMACAO_PODE_SER_CONSULTADA' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q3">{{'FAQ.COMO_CANCELAR_ACESSO_DADOS_BANCARIOS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q3"></button>
            <div id="q3" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_COMO_CANCELAR_ACESSO_DADOS_BANCARIOS' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q4">{{'FAQ.COMO_SABER_AUTORIZACAO' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q4"></button>
            <div id="q4" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_COMO_SABER_AUTORIZACAO' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q5">{{'FAQ.COMO_DADOS_BANCARIOS_FICAM_PROTEGIDOS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q5"></button>
            <div id="q5" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_COMO_DADOS_BANCARIOS_FICAM_PROTEGIDOS' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q6">{{'FAQ.O_QUE_SAO_ACESSOS_NAO_PRESENCIAIS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q6"></button>
            <div id="q6" class="collapse" style="margin-top:10px;">
            <span class="faq-answer">{{'FAQ.DESCRICAO_O_QUE_SAO_ACESSOS_NAO_PRESENCIAIS' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q7">{{'FAQ.O_QUE_SAO_ACESSOS_RECORRENTES_UNICOS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q7"></button>
            <div id="q7" class="collapse" style="margin-top:10px;">
             <span class="faq-answer">{{'FAQ.DESCRICAO_O_QUE_SAO_ACESSOS_RECORRENTES_UNICOS' | translate}}</span>
            </div>
        </div>

        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q8">{{'FAQ.QUAIS_SAO_OS_CUSTOS_ASSOCIADOS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q8"></button>
            <div id="q8" class="collapse" style="margin-top:10px;">
             <span class="faq-answer">{{'FAQ.DESCRICAO_QUAIS_SAO_OS_CUSTOS_ASSOCIADOS' | translate}}</span>
            </div>
        </div>

        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q9">{{'FAQ.O_QUE_AUTENTICACAO_FORTE' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q9"></button>
            <div id="q9" class="collapse" style="margin-top:10px;">
             <span class="faq-answer">{{'FAQ.DESCRICAO_O_QUE_AUTENTICACAO_FORTE' | translate}}</span>
            </div>
        </div>

        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q10">{{'FAQ.COMO_POSSO_USAR_OPEN_BANKING' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q10"></button>
            <div id="q10" class="collapse" style="margin-top:10px;">
             <span class="faq-answer">{{'FAQ.DESCRICAO_COMO_POSSO_USAR_OPEN_BANKING' | translate}}</span>
            </div>
        </div>
    </div>
    <div *ngIf="sessionData.agreementType === 'P'">
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q2">{{'FAQ.PODEM_SER_FEITOS_PAGAMENTOS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q2"></button>
            <div id="q2" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_PODEM_SER_FEITOS_PAGAMENTOS' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q3">{{'FAQ.POSSO_CANCELAR_PAGAMENTO' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q3"></button>
            <div id="q3" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_POSSO_CANCELAR_PAGAMENTO' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q4">{{'FAQ.COMO_SABER_AUTORIZACAO_PAGAMENTO' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q4"></button>
            <div id="q4" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_COMO_SABER_AUTORIZACAO_PAGAMENTO' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q5">{{'FAQ.COMO_DADOS_BANCARIOS_FICAM_PROTEGIDOS' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q5"></button>
            <div id="q5" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_COMO_DADOS_BANCARIOS_FICAM_PROTEGIDOS' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q7">{{'FAQ.QUE_CUSTOS_POSSO_TER' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q7"></button>
            <div id="q7" class="collapse" style="margin-top:10px;">
            <span class="faq-answer">{{'FAQ.DESCRICAO_QUE_CUSTOS_POSSO_TER' | translate}}</span>
            </div>
        </div>
        <div class="question-div">
            <div class="faq-question" data-bs-toggle="collapse" data-bs-target="#q8">{{'FAQ.POSSO_USAR_OPEN_BANKING' | translate}}</div>
            <button type="button" class="btn btn-info-more collapsed" data-bs-toggle="collapse" data-bs-target="#q8"></button>
            <div id="q8" class="collapse" style="margin-top:10px;">
                <span class="faq-answer">{{'FAQ.DESCRICAO_POSSO_USAR_OPEN_BANKING' | translate}}</span>
            </div>
        </div>
    </div>

   <div *ngIf="sessionData.agreementType === 'A' || sessionData.agreementType === 'P'" class="faq-more-info-div">
        <a href="https://www.santandertotta.pt/pt_PT/Particulares.html" target="blank" class="faq-more-info-link">{{'FAQ.MAIS_INFORMACAO' | translate}}</a>
   </div>

</aside>